module.exports = __webpack_public_path__ + "img/heart.f418cbaa.gif";